import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Lock } from "lucide-react";

export function FeatureGate({ feature, children }) {
  const [state, setState] = useState({ loading: true, allowed: false });
  useEffect(() => {
    api.get("/entitlements")
      .then((r) => setState({ loading: false, allowed: !!r.data.features?.[feature] }))
      .catch(() => setState({ loading: false, allowed: false }));
  }, [feature]);

  if (state.loading) return <div className="py-24 text-center text-slate-400">…</div>;
  if (state.allowed) return children;

  return (
    <div className="mx-auto max-w-lg rounded-sm border border-slate-200 bg-white p-10 text-center" data-testid="feature-gate-upsell">
      <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary"><Lock className="h-6 w-6" /></span>
      <h2 className="mt-4 font-head text-xl font-extrabold text-secondary">Función Empresarial</h2>
      <p className="mt-2 text-sm text-slate-500">Esta función está disponible en el plan <b>Empresarial</b>. Mejora tu suscripción para crear tu página web y recibir solicitudes de clientes.</p>
      <Link to="/dashboard/subscription" className="mt-5 inline-block rounded-sm bg-primary px-5 py-2.5 text-sm font-semibold text-white hover:bg-orange-600" data-testid="upgrade-cta">Mejorar plan</Link>
    </div>
  );
}
